/**
 * LifecycleWidgetsPage - Workflow lifecycle visualization
 *
 * Surfaces the LifecycleDashboardWidgets from @ferp/workflow-forms for admin/architect users.
 * Provides workflow instance lifecycle tracking and state transition visualization.
 *
 * Route: /admin/lifecycle-widgets
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { LifecycleDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function LifecycleWidgetsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="grape">
            <IconRefresh size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Lifecycle Widgets</Title>
            <Text size="sm" c="dimmed">
              Workflow instance lifecycle tracking and state transition visualization
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <LifecycleDashboard />
    </Container>
  );
}

export default LifecycleWidgetsPage;
